export const pluralize = (str: string) => {
  return str + 's';
};

export const snakeToCamel = (str: string) => {
  return str.replace(/(\w)(_)(\w)/, `${'$1'}${'$3'.toUpperCase()}`);
};
